import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllLanguagesList } from '../API/services/alkymersService';
import { setLanguagesAvailable } from '../redux/actions/testGroupCreatorActions';

// Default languages fallback - matches the old enum format
const defaultLanguagesList = [
  { label: 'Español', value: 'es', iso: 'ESP' },
  { label: 'English', value: 'en', iso: 'USA' },
  { label: 'Português', value: 'pt', iso: 'BRA' },
  // { label: 'Aleman', value: 'u', iso: 'DEU' }, // TO DO: incorporar alemán o eliminar. A consultar.
];

export const useLanguageTranslations = () => {
  const dispatch = useDispatch();
  const { languagesAvailable } = useSelector((state) => state.testGroups);

  const getLanguagesList = async () => {
    try {
      const languages = await getAllLanguagesList();
      return languages.map((l) => ({
        ...l,
        label: l.displayName,
        value: l.code,
      }));
    } catch (e) {
      console.error(`Error fetching languages: ${e}`);
      return defaultLanguagesList;
    }
  };

  useEffect(() => {
    const fetchLanguages = async () => {
      const list = await getLanguagesList();
      dispatch(setLanguagesAvailable(list));
    };

    if (languagesAvailable.length < 1) {
      fetchLanguages();
    }
  }, []);

  // Format languages to match the old enum structure
  const languagesList = useMemo(() => {
    if (languagesAvailable.length > 0) {
      return languagesAvailable.map((lang) => ({
        label: lang.displayName || lang.label,
        value: lang.code || lang.value,
        iso: lang.iso,
      }));
    }
    return defaultLanguagesList;
  }, [languagesAvailable]);

  return {
    testGroupLanguageList: languagesAvailable,
    languagesList, // Export formatted list matching enum structure
  };
};
